import { render, staticRenderFns } from "./SeletorDeLojasDoUsuario.vue?vue&type=template&id=aa23fc18&"
import script from "./SeletorDeLojasDoUsuario.vue?vue&type=script&lang=ts&"
export * from "./SeletorDeLojasDoUsuario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports